<template>
  <case-update-card
    :info-item="suspension"
    :icon="'mdi-account-group'"
    :header="local.caseFile.cards.suspension.header"
    :hasActions="true"
  >
    <template v-if="suspension" slot="actions" slot-scope="{}">
      <v-chip outlined :color="suspension.isActive ? 'primary' : 'red'" class="separated-items-chip">
        {{ suspensionStatus }}
      </v-chip>
    </template>

    <template v-if="suspension" slot="bottom-slot" slot-scope="{}">
      <div class="row px-2 header-text">
        <div class="py-1 text-c-green col-4">
          {{ local.caseFile.cards.suspension.typeDisplayName }}
        </div>
        <div class="py-1 text-info-value col-8" :title="local.caseFile.cards.suspension.typeDisplayName">
          {{ suspension.suspensionTypeName }}
        </div>
      </div>
      <div class="row px-2 header-text">
        <div class="py-1 text-c-green col-4">
          {{ local.caseFile.cards.suspension.concernedParty }}
        </div>
        <div class="py-1 text-info-value col-8" :title="local.caseFile.cards.suspension.concernedParty">
          {{ suspension.partyName }}
        </div>
      </div>
      <div
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.courtName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="local.home.tabCommon.courtName"
        >
          {{ suspension.courtName }}
        </div>
      </div>
      <div
        class="row px-2 header-text"
      >
        <div class="py-1  text-c-green col-4">
          {{ local.home.tabCommon.subCircleName }}
        </div>
        <div
          class="py-1  text-info-value col-8"
          :title="local.home.tabCommon.subCircleName"
        >
          {{ suspension.circleName }}
        </div>
      </div>
      <div class="row px-2 header-text">
        <div class="py-1 text-c-green col-4">
          {{ local.caseFile.cards.suspension.dateDisplayName }}
        </div>
        <div class="py-1 text-info-value col-8" :title="local.caseFile.cards.suspension.dateDisplayName">
          {{ toHijriDate(suspension.suspensionDate) }}
        </div>
      </div>
      <div class="row px-2 header-text">
        <div class="py-1 text-c-green col-4">
          {{ local.caseFile.cards.suspension.stopSuspensionDateDisplayName }}
        </div>
        <div class="py-1 text-info-value col-8" :title="local.caseFile.cards.suspension.stopSuspensionDateDisplayName">
          {{ suspension.stopSuspensionDate ? toHijriDate(suspension.stopSuspensionDate) : '-' }}
        </div>
      </div>
    </template>
  </case-update-card>
</template>

<script>
import { toHijriDate } from '@/helpers/utils';
import CaseUpdateCard from './case-update-card.vue';

export default {
  name: 'SuspensionCard',
  components: { CaseUpdateCard },
  props: {
    suspension: {
      type: Object,
      required: true,
    },
  },
  computed: {
    suspensionStatus() {
      return this.suspension.isActive
        ? this.local.caseFile.cards.suspension.activeStatus
        : this.local.caseFile.cards.suspension.inactiveStatus;
    },
  },
  methods: {
    toHijriDate,
  },
};
</script>

<style scoped>
.header-text {
  font-size: 18px;
}

::v-deep .case-update-card-header {
  color: var(--app-dark-primary-color);
  font-size: 25px;
}
.separated-items-chip {
  margin-left: 50px !important;
  border-radius: 20px !important;
  height: 30px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.separated-items-chip .v-chip__content {
  padding: 0 12px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 4px !important;
}
</style>
